import { render, staticRenderFns } from "./KnownMethodUpdate.vue?vue&type=template&id=23d898fa&"
import script from "./KnownMethodUpdate.vue?vue&type=script&lang=js&"
export * from "./KnownMethodUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports